// @flow
import type { Element, Node } from 'React';

import React from 'react';
import { Col } from 'reactstrap';

/* eslint-disable react/jsx-props-no-spreading */
type columnProps =
  | string
  | number
  | boolean
  | {|
      size: string | number | boolean,
      order: string | number,
      offset: string | number,
    |};

type Props = {|
  children?: Node,
  xs?: columnProps | null,
  sm?: columnProps | null,
  md?: columnProps | null,
  lg?: columnProps | null,
  xl?: columnProps | null,
  visible: boolean,
|};

const EnhancedFormGroupCol = ({
  children = null,
  xs = null,
  sm = null,
  md = null,
  lg = null,
  xl = null,
  visible,
  ...rest
}: Props): Element<typeof Col> | null => {
  if (visible === false) {
    return null;
  }
  return (
    <Col xs={xs} sm={sm} md={md} lg={lg} xl={xl} {...rest}>
      {children}
    </Col>
  );
};

export default EnhancedFormGroupCol;
